/**
 * Header 子组件导出
 * 所有子组件都是客户端组件，用于最大化服务端渲染
 */

export { LanguageSelector } from "./LanguageSelector"
export type { LanguageOption } from "./LanguageSelector"

export { UserProfile } from "./UserProfile"

export { MainNavigation } from "./MainNavigation"

export { HeaderContentWithScroll } from "./HeaderContentWithScroll"
export { ScrollProvider, useScroll } from "./ScrollContext"
export { ScrollHandler } from "./ScrollHandler"

export { SearchAndSubscribe } from "./SearchAndSubscribe"
